export enum TimeFormat {
    Twelve = 'hh:mm a', //12h
    TwentyFour = 'HH:mm' //24h
}

export enum TimeFormatSpecificity {
    Seconds = 'seconds',
    Milliseconds = 'milliseconds'
}